// Styles
import { makeStyles, createStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

type CreateProfileProps = { showAlert?: boolean };
type ProfileRowProps = { showFieldsInline?: boolean };

const useStyles = {
    createYourProfile: makeStyles<Theme, CreateProfileProps>((theme: Theme) =>
        createStyles({
            title: {
                fontSize: 24,
                fontWeight: 600,
                textAlign: "center",
                color: theme.palette.primary.dark,
                marginBottom: theme.spacing(2),
                [`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
                    fontSize: 20,
                },
            },
            createProfileWrapper: {
                maxWidth: 800,
                margin: `0 auto ${theme.spacing(4)}`,
                paddingLeft: theme.spacing(10),
                paddingRight: theme.spacing(10),
                "& .MuiLinearProgress-root": {
                    display: "block",
                    borderRadius: 8,
                    marginBottom: theme.spacing(3),
                    height: 6,
                },
                "& .MuiLinearProgress-bar": {
                    backgroundColor: theme.palette.secondary.main,
                },
            },
            infoContainer: {
                textAlign: "center",
                marginBottom: theme.spacing(4),
                [`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
                    marginBottom: theme.spacing(2),
                },
            },
            startedText: {
                marginTop: theme.spacing(1),
                color: theme.palette.text.secondary,
                fontSize: 12,
            },
            text: {
                fontWeight: 400,
                [`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
                    fontSize: 13,
                },
            },
            addRoleAction: {
                minWidth: "fit-content",
                padding: 0,
                "& .MuiSvgIcon-root": {
                    fontSize: 18,
                    marginRight: theme.spacing(1),
                },
                "& .MuiTypography-root": {
                    color: theme.palette.secondary.main,
                    fontSize: 11,
                    letterSpacing: "1.16px",
                    textDecoration: "underline",
                },
            },
            boxWrapper: {
                maxWidth: 1000,
                marginLeft: "auto",
                marginRight: "auto",
                paddingLeft: theme.spacing(2.5),
                paddingRight: theme.spacing(2.5),
            },
            whEntriesWrapper: {
                maxHeight: "35vh",
                overflowY: "auto",
                "@media (max-height: 850px)": {
                    maxHeight: ({ showAlert }) => (showAlert ? "20vh" : "30vh"),
                },
            },
        })
    ),
    profileRow: makeStyles<Theme, ProfileRowProps>((theme: Theme) =>
        createStyles({
            root: {
                marginBottom: theme.spacing(1),
                marginTop: theme.spacing(1),
                justifyContent: "space-evenly",
            },
            incompleteProfile: {
                background: theme.palette.background.grey,
            },
            column: {
                display: "flex",
                flexDirection: "column",
            },
            whEntryText: {
                fontSize: 12,
                fontWeight: ({ showFieldsInline }) => (showFieldsInline ? 500 : 700),
                marginBottom: theme.spacing(0.5),
            },
            checkboxLabel: {
                "& .MuiCheckbox-root": {
                    padding: theme.spacing(1, 0.5),
                    marginLeft: theme.spacing(1),
                },
                "& .MuiTypography-root": {
                    fontSize: 12,
                    color: theme.palette.text.secondary,
                    fontWeight: 600,
                },
            },
            deleteButton: {
                marginTop: theme.spacing(3.9),
                width: theme.spacing(3),
                height: theme.spacing(3),
                color: theme.palette.primary.main,
                opacity: "25%",
                "&:hover": {
                    opacity: "80%",
                },
            },
            textFieldPlaceHolder: {
                "& .MuiOutlinedInput-input": {
                    paddingLeft: theme.spacing(1.25),
                    paddingRight: theme.spacing(1.25),
                    "&::placeholder": {
                        fontSize: 12,
                    },
                },
                "& .MuiInputBase-adornedEnd": {
                    paddingRight: theme.spacing(1.2),
                },
                "& .MuiIconButton-root": {
                    visibility: "hidden",
                    padding: 0,
                    position: "absolute",
                    right: 10,
                },
                "&:hover, &:focus": {
                    "& .MuiIconButton-root": {
                        visibility: "visible",
                    },
                },
            },
            inputContainer: {
                marginBottom: ({ showFieldsInline }) => theme.spacing(showFieldsInline ? 0 : 2),
            },
            warningContainer: {
                alignContent: "center",
                color: theme.palette.warning.main,
            },
            missingFields: {
                background: theme.palette.background.red,
            },
        })
    ),
};

export default useStyles;
